import { Component, OnInit } from '@angular/core';
import {CoefService} from '../../service/coef.service';

@Component({
  selector: 'app-door-left-lock',
  templateUrl: './door-left-lock.component.html',
  styleUrls: ['./door-left-lock.component.scss']
})
export class DoorLeftLockComponent implements OnInit {

  constructor(public coef: CoefService) { }

  ngOnInit() {
  }

}
